<template>

    <div class="welcome-to-origo-component h-100">

        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12">
                    <div class="card">
                        <div class="row">
                            <div class="col-12 col-lg-6 left text-center">

                                <h1 class="text-uppercase">Set your new <span>password</span></h1>

                                <div style="background-color:#eee;padding:12px 8px;">
                                    Your password must contain: Min <b>8 characters</b>,<br> <b>1 capital letter</b> & at least <b>1 number</b>
                                </div>

                                <form @submit.prevent="reset" id="login-form">
                                    <input type="hidden" v-model="payload.body_params.passwordResetToken" required>
                                    <div class="input">
                                        <input type="text" class="username" id="username" v-model="payload.body_params.userName" autocomplete="off" required>
                                        <label for="username"><i class="icon-profile"></i> Email Address</label>
                                    </div>
                                    <div class="input">
                                        <input type="password" class="password" id="newPassword" v-model="payload.body_params.newPassword" autocomplete="off" required>
                                        <label for="newPassword"><i class="icon-password"></i> Choose a new password</label>
                                    </div>
                                    <div class="input">
                                        <input type="password" class="password" id="newPasswordConfirmation" v-model="newPasswordConfirmation" autocomplete="off" required>
                                        <label for="newPasswordConfirmation"><i class="icon-password"></i> Confirm your new password</label>
                                    </div>
                                    <div>
                                        <button type="submit" class="button button--steelBlue w-100">Submit <i class="icon-arrow-right"></i></button>
                                    </div>
                                </form>

                            </div>
                            <div class="col-12 col-lg-6 right text-center">
                                <div class="d-flex flex-column h-100 justify-content-center">
                                    <div>
                                        <i class="logo-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import router from '../router';
    import {EventBus} from '@/event-bus.js';

    export default {
        data() {
            return {
                'payload': {
                    'body_params': {
                        'userName': null,
                        'passwordResetToken': null,
                        'newPassword': null,
                    },
                    'method': 'PUT',
                    'endpoint': 'users/resetPassword',
                    'requiresBearerToken': false,
                },
                'newPasswordConfirmation': null
            };
        },
        created() {
            this.payload.body_params.passwordResetToken = this.$route.query.code;
        },
        methods: {
            reset() {
                if (this.payload.body_params.newPassword !== this.newPasswordConfirmation) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: 'Password and Password Confirmation do not match'
                    })
                } else {

                    EventBus.$emit('loadingTitle', 'Updating password');
                    EventBus.$emit('loading', true);

                    this.$http.post('/api/reset-password', this.payload)
                    .then(response => {
                        EventBus.$emit('loading', false);
                        if (response.data.status == 200) {
                            this.$notify({
                                group: 'notify',
                                type: 'success',
                                title: 'Success',
                                text: 'Password reset successful. Please log in.'
                            })
                            this.$router.push('/login');
                        } else if (response.data.status == 'error') {
                            const error = (
                                response.data.error.modelState && response.data.error.modelState.resetPassword && response.data.error.modelState.resetPassword[0]
                                    ? response.data.error.modelState.resetPassword[0]
                                    : 'Could not reset password'
                            );

                            this.$notify({
                                group: 'notify',
                                type: 'error',
                                title: 'Error',
                                text: error
                            })
                        }
                    });
                }
            },
        },
    }
</script>
